export enum NotificationType {
  Success,
  Error,
  Info
}

export class ErrorNotification {
  code: string = "";
  message: string | null = null;
  params: string[] | null = null;
}

export class Notification {
  title: string = "";
  description: string | null = null;
  type: NotificationType = NotificationType.Info;

  constructor(
    title: string,
    description: string | null,
    type: NotificationType
  ) {
    this.title = title;
    this.description = description;
    this.type = type;
  }

  public static Convert(error: ErrorNotification) {
    return new Notification(
      "Atenção",
      error.message || "",
      NotificationType.Error
    );
  }

  public static ConvertFromAxios(error: any) {
    if (error && error.response && error.response.data) {
      const errors = error.response.data as ErrorNotification[];
      if (errors.length > 0) {
        return Notification.Convert(errors[0]);
      } else {
        return new Notification(
          "Operação inválida",
          null,
          NotificationType.Error
        );
      }
    } else {
      return new Notification(
        "Connection",
        "Check your connection",
        NotificationType.Error
      );
    }
  }
}
